























































import { Component, Vue } from 'vue-property-decorator';
import { PDFViewer } from 'web-pdf-viewer';
import { REPORT } from '../../utils/request/API';
import { Form } from 'element-ui';
import PageHeader from '@/components/PageHeader.vue';
import Empty from '@/components/Empty.vue';
import { getTime } from '@/utils/helpers/fileDate';

@Component({
  components: { PageHeader, Empty },
})
export default class ReportUpload extends Vue {
  pv: PDFViewer | null = null;

  pdf = {
    fileType: 'PDF',
    fileName: '',
    fileSize: 0,
    filePath: '',
    fileRealPath: '',
  };

  isUploading = false;

  typelist = [];

  pdfinfo: PlainObject = {
    reportName: this.$route.query.name || '',
    releaseTime: this.$route.query.dt || getTime(new Date()), //发布时间
    overrideMotion: false,
  };

  rules = {
    reportName: [
      { required: true, message: '请输入报告名称', trigger: 'blur' },
      { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' },
    ],
    releaseTime: [
      {
        type: 'date',
        required: true,
        message: '请选择发布时间',
        trigger: 'change',
      },
    ],
  };

  isSubmitting = false;

  meetName = '';
  reportLang = '';

  Upload({ target: { files } }: { target: { files: File[] } }) {
    const fileName = files.length ? files[0].name.replace(/\.[^.]*$/, '') : '';
    const splitArr = fileName.split('-');
    if (this.$route.query.md && this.$route.query.sc) {
      if (
        (splitArr.length && splitArr[0] !== this.$route.query.md) ||
        (splitArr.length > 1 && splitArr[1] !== this.$route.query.sc)
      ) {
        // console.log(this.$route.query, '-', splitArr);
        this.$message({
          type: 'error',
          message: '请确认是否上传的是正确的报告',
        });
        return;
      }
    }
    if (this.isUploading) return;
    this.isUploading = true;

    if (this.pv) this.pv?.destroy();

    const params = new FormData();
    params.append('file', files[0]);
    this.$axios(REPORT.UPLOADPDF, params)
      .then(res => {
        this.pdf = res.data;
        this.RenderPdf();
        if (!this.pdfinfo.reportName)
          this.pdfinfo.reportName = res.data.fileName.replace(/\.[^.]*$/, '');
      })
      .catch(err => {
        console.error(err);
        this.$message({ type: 'error', message: '上传失败' });
      })
      .finally(() => (this.isUploading = false));
    (this.$refs.upload as HTMLInputElement).value = '';
  }

  RenderPdf() {
    this.pv = new PDFViewer({
      cmaps: '../../../public/cmaps/',
      container: this.$refs.pdfbox as HTMLElement,
      url: '/file/' + this.pdf.filePath,
      isRenderText: true,
      //   containerBackground:
      //   borderStyle:
      gap: 0,
      // pdfjsParams: {},
    });
    this.pv.addEventListener('load', (e: PlainObject) => {
      // const scale = e.pv.pages[0].width / e.pv.firstPageOriginWidth;
      // const width = e.pv.firstPageOriginWidth;
      e.pv.renderPage(1, 100);
    });
  }

  Submit() {
    const form = this.$refs.form as Form;
    form.validate(valid => {
      if (!valid) return false;
      if (!this.pdf.fileRealPath) {
        this.$message({ type: 'error', message: '请上传报告' });
        return;
      }
      if (this.isSubmitting) return;
      this.isSubmitting = true;

      const params = {
        reportType: this.$route.query.type,
        partnerMeetId: this.$route.query.meetid,
        partnerMeetReportId: this.$route.query.taskid,
        ...this.pdf,
        ...this.pdfinfo,
        overrideMotion: this.meetName ? true : this.pdfinfo.overrideMotion,
      };
      this.$axios(REPORT.UPLOAD, params)
        .then(() => {
          this.$message({ type: 'success', message: '操作成功' });
          this.Cancle();
        })
        .catch(err => {
          console.error(err);
          this.$message({ type: 'error', message: '操作失败' });
        })
        .finally(() => (this.isSubmitting = false));
    });
  }

  Cancle() {
    history.back();
  }

  Resize() {
    this.pv?.resize();
  }

  mounted() {
    this.meetName = (this.$route.query.meetName as string) || '';
    this.reportLang = (this.$route.query.reportLang as string) || '';

    const { type, meetid, taskid } = this.$route.query;
    if (!meetid || !taskid || !type) {
      this.Cancle();
      return;
    }
    (this.$refs.upload as HTMLElement).dispatchEvent(new MouseEvent('click'));
    window.addEventListener('resize', this.Resize);
  }

  beforeDestroy() {
    this.pv?.destroy();
    window.removeEventListener('resize', this.Resize);
  }
}
